import styles from "./styles.module.scss";

export const SpinnerLoader = () => {
  return <div className={styles.loader}></div>;
};

export const SpinnerLoaderSmall = () => {
  return <div className={styles.loader__small}></div>;
};
